import React from 'react';
import PropTypes from 'prop-types';

export class FormGroup extends React.Component {
    render() {
        const { children, legend } = this.props;
        return (
            <fieldset className="form-group">
                {legend && <legend>{legend}</legend>}
                {children}
            </fieldset>
        );
    }
}

FormGroup.propTypes = {
    children: PropTypes.node,
    legend: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default FormGroup;
